var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburgerBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_405_63688)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19834 5.97806C6.37513 5.97806 5.70593 6.74869 5.70593 7.69538C5.70593 8.64207 6.37513 9.41271 7.19834 9.41271H25.0487C25.8719 9.41271 26.542 8.64207 26.542 7.69538C26.542 6.74869 25.8719 5.97806 25.0487 5.97806H7.19834ZM25.0485 10.4669H7.19819C5.86987 10.4669 4.78906 9.224 4.78906 7.69538C4.78906 6.16676 5.86987 4.92383 7.19819 4.92383H25.0485C26.3777 4.92383 27.4585 6.16676 27.4585 7.69538C27.4585 9.224 26.3777 10.4669 25.0485 10.4669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2489 14.0581C12.4257 14.0581 11.7565 14.8288 11.7565 15.7755C11.7565 16.7222 12.4257 17.4917 13.2489 17.4917H24.959C25.7822 17.4917 26.4524 16.7222 26.4524 15.7755C26.4524 14.8288 25.7822 14.0581 24.959 14.0581H13.2489ZM24.9591 18.546H13.249C11.9207 18.546 10.8398 17.303 10.8398 15.7755C10.8398 14.2468 11.9207 13.0039 13.249 13.0039H24.9591C26.2883 13.0039 27.3691 14.2468 27.3691 15.7755C27.3691 17.303 26.2883 18.546 24.9591 18.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2908 22.1383C17.4676 22.1383 16.7984 22.909 16.7984 23.8556C16.7984 24.8023 17.4676 25.5719 18.2908 25.5719H24.4567C25.2799 25.5719 25.95 24.8023 25.95 23.8556C25.95 22.909 25.2799 22.1383 24.4567 22.1383H18.2908ZM24.4567 26.6261H18.2909C16.9626 26.6261 15.8818 25.3832 15.8818 23.8556C15.8818 22.327 16.9626 21.0841 18.2909 21.0841H24.4567C25.786 21.0841 26.8668 22.327 26.8668 23.8556C26.8668 25.3832 25.786 26.6261 24.4567 26.6261Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_405_63688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerBtn);
export default __webpack_public_path__ + "static/media/hamburger_btn.d5bfbb3c0a90f99b48d5de677353d804.svg";
export { ForwardRef as ReactComponent };